import React, { useState } from 'react';
import axios from 'axios';
import './FeedbackPage.css'; // 1. CHANGE CSS IMPORT

const FeedbackPage = () => {
  const [type, setType] = useState('Suggestion');
  const [message, setMessage] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message) {
      alert('Please enter your feedback message.');
      return;
    }
    setSubmitting(true);
    setError('');
    setSuccessMessage('');

    try {
      const feedbackData = { type, message, contactEmail };
      const res = await axios.post(`${apiUrl}/api/feedback`, feedbackData);

      setSuccessMessage(res.data.message || 'Feedback submitted successfully!');
      setMessage('');
      setContactEmail('');
      setType('Suggestion');

    } catch (err) {
      console.error('Error submitting feedback:', err.response?.data || err);
      setError(err.response?.data?.message || 'Failed to submit feedback.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    // 2. UPDATE CLASSNAMES
    <div className="feedback-container">
      <div className="feedback-form-card">
        <h4>Submit Website Feedback</h4>
        <p className="form-intro-text">
          Have suggestions or found a bug? Let us know!
        </p>

        {successMessage && <p className="form-success">{successMessage}</p>}
        {error && <p className="form-error">{error}</p>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="feedbackType">Feedback Type *</label>
            <select
              id="feedbackType"
              value={type}
              onChange={(e) => setType(e.target.value)}
              className="feedback-select" // UPDATE CLASS
              required
            >
              <option value="Suggestion">Suggestion</option>
              <option value="Bug Report">Bug Report</option>
              <option value="General">General Comment</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="feedbackMessage">Message *</label>
            <textarea
              id="feedbackMessage"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="feedback-textarea" // UPDATE CLASS
              placeholder="Please provide details..."
              rows="6"
              required
            ></textarea>
          </div>

          <div className="form-group">
            <label htmlFor="contactEmail">Your Email (Optional)</label>
            <input
              type="email"
              id="contactEmail"
              value={contactEmail}
              onChange={(e) => setContactEmail(e.target.value)}
              className="feedback-input" // UPDATE CLASS
              placeholder="If you'd like a response"
            />
          </div>

          <button type="submit" className="btn-submit-feedback" disabled={submitting}>
            {submitting ? 'Submitting...' : 'Send Feedback'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default FeedbackPage;